module.exports = __webpack_public_path__ + "img/lukasik.bd5c107f.jpg";